import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PartnerGroupList = lazy(
  () => import('@components/PartnerGroup/PartnerGroupList')
);

/** 파트너 계정 > 조합 관리 */
const PartnerGroup = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <PartnerGroupList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default PartnerGroup;
